module.exports = {
    // base_url: "http://localhost:5000/" //temporarly
    base_url: "https://rangka-form-backend.komunestudio.com/"
    //base_url: "http://localhost:4100/"
    //base_url: "https://read-indonesia-api.komunestudio.com/"
    // base_url: 'https://staging-api.readindonesia.id/',
    // base_url: "https://barcode-api.komunestudio.com/"
    
};
